import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'
import { useNavigate } from 'react-router'

import { usePolicyholderAdjustment } from '../../hooks/adjustments/policyholder'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'
import { useUpButton } from '../../infrastructure/routing'
import { InputConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { usePolicyholder } from '../authentication'
import { FormErrors } from '../formBuilder'
import { FullPage } from '../templates'

const tKey = TKey('pages.account-setting')

export interface AccountSettingProps {
  input: InputConfig
}

export const AccountSetting: FunctionComponent<AccountSettingProps> = ({ input }) => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const upButton = useUpButton({ url: AppPath.ACCOUNT, id: 'account-settings' })

  const { policyholder } = usePolicyholder()

  const inputs = useMemo(() => [input], [input])

  const onSubmit = usePolicyholderAdjustment(() => navigate(AppPath.ACCOUNT))

  return policyholder ? (
    <FullPage header={t(tKey('headers', input.name))} upButton={upButton}>
      <FormErrors
        id={input.name}
        data={policyholder ?? {}}
        config={inputs}
        onSubmit={onSubmit.execute}
        loading={onSubmit.loading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </FullPage>
  ) : (
    <PageLoadingIndicator />
  )
}
